<template>
    <ion-page class="ion-page" id="main">
        <default-header>
            <template v-slot:start>
                <ion-buttons slot="start">
                    <header-menu/>
                </ion-buttons>
            </template>
        </default-header>
        <ion-content fullscreen>
            <flash-messages/>

            <ion-item v-if="!canUploadMore && !loading" color="danger" @click="upgrade" button>
                <ion-text style="padding: 5px 0;">
                    {{ $t('ncrypt.vault.limit_reached_upgrade_to_add_files_notification') }}
                </ion-text>
            </ion-item>

            <div v-if="loading" style="margin: 200px 0; display: flex; justify-content: center;">
                <ion-spinner></ion-spinner>
            </div>
            <ion-grid v-else>
                <vault-header :files="files" :filesAmountLimit="filesAmountLimit"
                              :usedSize="usedSize" :usedSizeReadable="usedSizeReadable"
                              :availableSize="availableSize" :availableSizeReadable="availableSizeReadable"
                />
                <ion-row>
                    <ion-col>
                        <vault-file-list :files="files"  v-on:refresh="loadFiles"/>
                    </ion-col>
                </ion-row>
                <ion-row>
                    <ion-col>
                        <vault-add-file :limitReached="!canUploadMore" v-on:upgrade="upgrade" v-on:completed="loadFiles"/>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </ion-content>
    </ion-page>
</template>
<script>

    import DefaultHeader from "../../components/nav/DefaultHeader";
    import FlashMessages from "../../components/ui-elements/FlashMessages";
    import HeaderMenu from "../../components/nav/HeaderMenu";
    import VaultFileList from "../../components/vault/VaultFileList";
    import VaultAddFile from "../../components/vault/VaultAddFile";
    import VaultHeader from "../../components/vault/VaultHeader";
    import {ApiError} from "../../errors/ApiError";
    import {MenuHandler} from "../../services/MenuHandler";

    export default {
        components: {VaultHeader, VaultAddFile, VaultFileList, HeaderMenu, FlashMessages, DefaultHeader},
        data() {
            return {
                loading: true,
                usedSize: undefined,
                usedSizeReadable: undefined,
                availableSize: undefined,
                availableSizeReadable: undefined,
                files: [],
                filesAmountLimit: undefined,
            }
        },
        computed: {
            canUploadMore() {
                if (this.availableSize >= 0 && this.usedSize >= this.availableSize) {
                    return false;
                }

                if (this.filesAmountLimit >= 0 && this.files.length >= this.filesAmountLimit) {
                    return false;
                }

                return true;
            },
        },
        methods: {
            upgrade() {
                MenuHandler.open('pro');
            },
            loadFiles() {
                this.loading = true;

                this.$http.get('/vault/files')
                    .then(async ({data}) => {
                        if (!data) {
                            new ApiError(data);
                            return;
                        }

                        this.filesAmountLimit = data.file_limit;
                        this.availableSize = data.storage_limit;
                        this.availableSizeReadable = data.storage_limit_readable;
                        this.usedSize = data.used_size;
                        this.usedSizeReadable = data.used_size_readable;
                        this.files = data.files;
                    })
                    .catch(reason => new ApiError(reason))
                    .finally(() => this.loading = false);
            },
        },
        mounted() {
            this.loadFiles();
        },
    }
</script>
